var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./AwardsEmmyPopup.jinja');
require('./AwardsEmmyPopup.less');

var CommonSidebar = require('front/components/CommonSidebar/CommonSidebar');
var AwardsCommonWinnersList = require('front/components/AwardsCommonWinnersList/AwardsCommonWinnersList');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSidebar': {selector: '.CommonSidebar', viewConstructor: CommonSidebar}
    },

    events: _.extend({
        'click .AwardsEmmyPopup-yearSelector': 'toggleYearDropdown'
    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['front:api:awards_emmy-popup'](this.year, 'json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },

    initialize: function (options) {
        this.options = options || {};

        this.year = this.options.year;

        _.bindAll(this, 'onBodyClick');

        BasePopup.prototype.initialize.call(this, options);
    },


    toggleYearDropdown: function (e) {
        var $selector = this.$('.AwardsEmmyPopup-yearSelector');
        var dropdownClass = '.AwardsEmmyPopup-yearSelectorDropdown';
        var activeModifier = 'AwardsEmmyPopup-yearSelector--active';

        if ($(e.target).closest(dropdownClass).length) return;

        if ($selector.hasClass(activeModifier)) {
            $selector.find(dropdownClass).slideUp(200);
            $selector.removeClass(activeModifier);
            $('body').off('click', this.onBodyClick);
        } else {
            $selector.find(dropdownClass).slideDown(200);
            $selector.addClass(activeModifier);
            $('body').on('click', this.onBodyClick);
        }
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.AwardsEmmyPopup-yearSelector').length) return;

        this.toggleYearDropdown(e);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.js
// module id = 252
// module chunks = 0